import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/materials/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/materials/:materialId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/materials/:materialId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/materials/:materialId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].CREATE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/materials/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].PATCH_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/materials/:materialId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].PUT_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/materials/:materialId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].DELETE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/materials/:materialId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}